import { useContext } from "react";
import { Context } from "../context/Context";
import { Link, useNavigate } from "react-router-dom";
import "./Menu.css";

const Menu = () => {
  const { page, rooms, currentRoom, equipments, setSelectedEquipment } =
    useContext(Context);
  const { handleShowDetailMenu, setSettingsPage } = useContext(Context);
  const navigate = useNavigate();
  const handleEquipment = () => {
    let roomId = currentRoom ? currentRoom : rooms?.[0]?.id;
    let equipment = equipments.find((eq) => eq.room_id == roomId);
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };
  return (
    <>
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme d-none d-lg-block"
      >
        <ul className="menu-inner py-1">
          {/* Layouts */}

          <li
            className={
              page.slug === "home"
                ? "menu-item active"
                : "menu-item text-color-def"
            }
          >
            <Link
              onClick={(e) => {
                e.preventDefault();
                handleEquipment();
              }}
              className="menu-link"
            >
              <i className="menu-icon tf-icons bx bx-home-circle"></i>
              {/* <div data-i18n="Container">خانه</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "planning" ||
              page.slug === "planning/scenario-list" ||
              page.slug === "planning/scenario" ||
              page.slug == "planning/schedule" ||
              page.slug == "planning"
                ? "menu-item active"
                : "menu-item text-color-def"
            }
          >
            <Link to="/planning/scenario-list" className="menu-link">
              <i className="menu-icon tf-icons bx bx-time-five"></i>
              {/* <div data-i18n="Container">برنامه ریزی</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "devices"
                ? "menu-item active"
                : "menu-item text-color-def"
            }
          >
            <Link to="/devices" className="menu-link">
              <i className="menu-icon tf-icons bx bx-devices"></i>
              {/* <div data-i18n="Container">دستگاه ها</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "settings" ||
              page.slug === "backup-management" ||
              page.slug === "about-us" ||
              page.slug === 'help'
                ? "menu-item active"
                : "menu-item text-color-def"
            }
          >
            <Link
              to="/settings"
              className="menu-link"
              onClick={() => {
                setSettingsPage({
                  name: "",
                  slug: "",
                });
              }}
            >
              <i className="menu-icon tf-icons bx bx-cog"></i>
              {/* <div data-i18n="Container">تنظیمات</div> */}
            </Link>
          </li>

          <li
            className={
              page.slug === "profile"
                ? "menu-item active"
                : "menu-item text-color-def"
            }
          >
            <Link to="/profile" className="menu-link">
              <i className="menu-icon tf-icons bx bx-user"></i>
              {/* <div data-i18n="Container">تنظیمات</div> */}
            </Link>
          </li>
        </ul>
      </aside>
      <aside
        className="bottom-menu bg-menu-theme w-100 position-fixed d-lg-none bottom-0"
        style={{ zIndex: "1000" }}
      >
        <ul className="py-1 mb-0 d-flex justify-content-around">
          {/* Layouts */}

          <li
            className={page.slug === "home" ? "menu-item active" : "menu-item"}
          >
            <Link
              onClick={(e) => {
                e.preventDefault();
                handleEquipment(
                  equipments.find((eq) => eq.room_id == rooms?.[0]?.id),
                  rooms?.[0]?.id,
                );
              }}
              className="menu-link"
            >
              <i className="menu-icon tf-icons bx bx-home-circle"></i>
              {/* <div data-i18n="Container">خانه</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "planning" ||
              page.slug === "planning/scenario-list" ||
              page.slug === "planning/scenario" ||
              page.slug == "planning/schedule" ||
              page.slug == "planning"
                ? "menu-item active"
                : "menu-item"
            }
          >
            <Link to="/planning/scenario-list" className="menu-link">
              <i className="menu-icon tf-icons bx bx-time-five"></i>
              {/* <div data-i18n="Container">برنامه ریزی</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "devices" ? "menu-item active" : "menu-item"
            }
          >
            <Link to="/devices" className="menu-link">
              <i className="menu-icon tf-icons bx bx-devices"></i>
              {/* <div data-i18n="Container">دستگاه ها</div> */}
            </Link>
          </li>
          <li
            className={
              page.slug === "settings" ||
              page.slug === "backup-management" ||
              page.slug === "about-us" || 
              page.slug === 'help'
                ? "menu-item active"
                : "menu-item"
            }
          >
            <Link
              to="/settings"
              className="menu-link"
              onClick={() => {
                setSettingsPage({
                  name: "",
                  slug: "",
                });
              }}
            >
              <i className="menu-icon tf-icons bx bx-cog"></i>
              {/* <div data-i18n="Container">تنظیمات</div> */}
            </Link>
          </li>

          <li
            className={
              page.slug === "profile" ? "menu-item active" : "menu-item"
            }
          >
            <Link to="/profile" className="menu-link">
              <i className="menu-icon tf-icons bx bx-user"></i>
              {/* <div data-i18n="Container">تنظیمات</div> */}
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Menu;
